import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { getIsArrayEmpty } from 'utils';

import './ListingHighlights.styles.scss';

type ListingHighlightsProps = {
  className?: string;
  to?: string;
  highlights: string[];
};

const ListingHighlights: React.FC<ListingHighlightsProps> = (props) => {
  const { className, to, highlights } = props;

  const classes = classNames('listing-highlights', className);

  if (getIsArrayEmpty(highlights)) return null;

  return (
    <ul className={classes}>
      {highlights.slice(0, 2).map((highlight) => (
        <li key={highlight}>
          <div>{to ? <Link to={to}>{highlight}</Link> : highlight}</div>
        </li>
      ))}
    </ul>
  );
};

export default ListingHighlights;
